import { NodeUtils } from '@ssml-editor/vue';
import { BREAK_TYPE } from './constant.js';

const breakPlugin = (editor) => {
  const { isInline, isVoid } = editor;
  const newEditor = editor;
  newEditor.isInline = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === BREAK_TYPE) return true;
    return isInline(element);
  };
  newEditor.isVoid = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === BREAK_TYPE) return true;
    return isVoid(element);
  };
  return newEditor;
};

export { breakPlugin };
//# sourceMappingURL=plugin.js.map
